import React from 'react'
import Card from 'react-bootstrap/Card'
import { Tooltip } from 'react-tooltip'

export default function LearnerBadge(props) {

    const { badge } = props

    return (
        <>
            <div className="row">
                {badge && badge.map((value, index) =>
                    <div className="col-md-3" key={index}>

                        <Card className='text-center mb-2'>
                            <Card.Img variant="top" src={value && value.lms_sub_badge && process.env.REACT_APP_IMAGE_URL + value.lms_sub_badge.badge_icon}
                                data-tooltip-id={`approve${index}`}
                                // data-tooltip-content={value && value.lms_master_badge && value.lms_master_badge.badge_name}
                                data-tooltip-place="bottom"
                            />
                            {/* <Card.Body style={{ lineHeight: '0.5' }}>
                                <h6>{value && value.lms_master_badge && value.lms_master_badge.badge_name}</h6>
                                <span>{value && value.lms_sub_badge && value.lms_sub_badge.sub_badges_name}</span>
                            </Card.Body> */}
                        </Card>

                        <Tooltip id={`approve${index}`} style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: '0.5' }} >
                            <div className='text-center'>
                                <p>{value && value.lms_master_badge && value.lms_master_badge.badge_name}</p>
                                <span>{value && value.lms_sub_badge && value.lms_sub_badge.sub_badges_name}</span>
                            </div>
                        </Tooltip>
                    </div>
                )}
            </div>
        </>
    )
}
